export function isUnauthorizedSessionError(status?: number): boolean {
  return status === 401;
}
